import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {SubtabMenu} from '../../../graphql/generated/types';
import {GnbMenuId} from '../constant';
import {Menu, MenuState} from '../type';

export const initialState: MenuState = {
  menu: {
    subtabMenuList: [],
  },
  entities: {
    subtabMenuMap: {},
    subtabMap: {},
  },
  relations: {
    subtabMenuMap: {},
    subtabMap: {},
  },
  isMobileGnbExposed: false,
  isPcHeaderExposed: false,
};

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenu: (state, action: PayloadAction<Menu>): void => {
      state.menu = action.payload;
    },
    setSubtabMenuMap: (
      state,
      action: PayloadAction<{
        subtabMenuList: SubtabMenu[];
      }>
    ): void => {
      const {subtabMenuList} = action.payload;
      subtabMenuList.forEach(subtabMenu => {
        state.entities.subtabMenuMap[subtabMenu.uid] = subtabMenu;
        state.relations.subtabMenuMap[subtabMenu.uid] = {childrenUids: []};
        subtabMenu.screenList.forEach(screen => {
          state.entities.subtabMap[screen.uid] = screen;
          state.relations.subtabMenuMap[subtabMenu.uid].childrenUids.push(
            screen.uid
          );
          state.relations.subtabMap[screen.uid] = {
            parentUid: subtabMenu.uid,
          };
        });
      });
    },
    selectGnbMenu: (state, action: PayloadAction<GnbMenuId>): void => {
      state.selectedGnbMenuId = action.payload;
    },
    setIsMobileGnbExposed: (state, action: PayloadAction<boolean>): void => {
      state.isMobileGnbExposed = action.payload;
    },
    setIsPcHeaderExposed: (state, action: PayloadAction<boolean>): void => {
      state.isPcHeaderExposed = action.payload;
    },
  },
});

export const {
  setMenu,
  setSubtabMenuMap,
  selectGnbMenu,
  setIsMobileGnbExposed,
  setIsPcHeaderExposed,
} = menuSlice.actions;
